module.exports = __webpack_public_path__ + "static/media/advs3.51c296c4.png";